import { Box, Link, Typography } from '@mui/material';
import { HelpArticle } from './types';

const HelpArticleBody = ({ article }: { article: HelpArticle }) => <Box>
  {article.blocks.map((block, index) => {
    if (block.type === 'heading') return <Typography
      key={block.anchor}
      id={block.anchor}
      variant={block.level === 2 ? 'h4' : 'h5'}
      component={block.level === 2 ? 'h2' : 'h3'}
      tabIndex={-1}
      sx={{ mt: index === 0 ? 0 : 4, mb: 1.5, scrollMarginTop: 88 }}>
      <Link href={`#${block.anchor}`} color="inherit" underline="hover">{block.text}</Link>
    </Typography>;
    if (block.type === 'list') return <Box component="ul" key={`list-${index}`} sx={{ pl: 3, my: 1.5 }}>
      {block.items.map(item => <Typography component="li" key={item} sx={{ mb: 0.75, lineHeight: 1.7 }}>{item}</Typography>)}
    </Box>;
    if (block.type === 'resource-link') return <Box key={`resource-link-${index}`} sx={{ mb: 1.25 }}>
      <Link href={block.href} target="_blank" rel="noopener noreferrer" sx={{ display: 'inline-flex', minHeight: 44, alignItems: 'center', fontWeight: 700 }}>{block.text}</Link>
    </Box>;
    return <Typography key={`paragraph-${index}`} sx={{ mb: 2, lineHeight: 1.75 }}>{block.text}</Typography>;
  })}
</Box>;

export default HelpArticleBody;
